import * as React from 'react';
import { supernovaColor } from '../types';

interface ToolLoadingStateProps {
  toolName: string;
  className?: string;
}

// Define the keyframes animation
const progressAnimation = `
  @keyframes progressAnimation {
    0% {
      left: -30%;
      width: 30%;
    }
    50% {
      width: 30%;
    }
    100% {
      left: 100%;
      width: 30%;
    }
  }
`;

/**
 * Tool Loading State Component
 * 
 * Displays a loading state for tool invocations in the Nova AI Chat.
 */
export function ToolLoadingState({ toolName, className = '' }: ToolLoadingStateProps) {
  // Format the tool name to be more user-friendly
  const displayName = toolName === 'sqlQuery' ? 'query' : toolName;
  
  // Add the animation to the document head
  React.useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = progressAnimation;
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);
  
  return (
    <div 
      className={`flex flex-col space-y-3 rounded-md p-3 w-full ${className}`}
      style={{ 
        background: `linear-gradient(135deg, ${supernovaColor.background} 0%, ${supernovaColor.lighter} 100%)`,
        borderLeft: `2px solid ${supernovaColor.main}`
      }}
    >
      <div className="flex flex-col space-y-2">
        <span 
          className="text-sm font-medium"
          style={{ 
            background: `linear-gradient(to right, ${supernovaColor.dark}, ${supernovaColor.main})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Processing...
        </span>
        
        <div className="relative w-full h-1.5 overflow-hidden rounded-full bg-white/50">
          <div 
            className="absolute top-0 left-0 h-full rounded-full"
            style={{ 
              background: `linear-gradient(to right, ${supernovaColor.main}, ${supernovaColor.light})`,
              width: '30%',
              animation: 'progressAnimation 1.5s ease-in-out infinite'
            }}
          ></div>
        </div>
      </div>
    </div>
  );
} 